<template>
  <v-container fluid>
    <section>
      <h1> Modal Demo Page</h1>

      <v-card max-width="500">
        <v-img :src="`https://picsum.photos/640/${imageHash}`"></v-img>
        <v-card-text>
          {{scope1}}
          {{scope2}}
          <p>event payload:{{eventPayload}}</p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="handleDemo1Click">Value</v-btn>
          <v-btn @click="handleDemo2Click">Model</v-btn>
          <v-btn @click="handleDemo3Click">Bus</v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        max-width="500"
        class="mt-5"
      >
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="6">
                <vf-currency-input
                  v-model="contractValue"
                  :currency="currency"
                  :currencies="currencies"
                  outlined
                >
                </vf-currency-input>
                <vf-currency-input
                  v-model="contractValue"
                  :currency="currencies[0]"
                  :currencies="currencies"
                  outlined
                >
                </vf-currency-input>
              </v-col>
              <v-col cols="6">
                {{contractValue}} eurocents
              </v-col>
              <v-col cols="6">
                <vf-date-input
                  outlined
                  v-model="contractDate"
                  format="DD.MM-YYYY"
                ></vf-date-input>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="contractDate">
                </v-text-field>
                {{contractDate}}
              </v-col>
              <v-col cols="6">
                <vf-percentage-input
                  v-model="percentageValue"
                  :inputValue="contractValue"
                  :outputValue.sync="calculatedValue"
                  outlined
                >

                </vf-percentage-input>
              </v-col>
              <v-col cols="6">
                {{percentageValue}}<br>
                {{calculatedValue}}
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>
      </v-card>
    </section>
    <v-spacer><br /></v-spacer>
    <section>
      <h1>Contracts</h1>

      <!-- temporary elements... just for presentation of charts -->
      <v-row>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-card class="pa-4">
            <h1>Pie Charts</h1>
            <div class="d-flex mt-2 justify-space-between">
              <chart-pie
                v-for="(group, index) in pie_data"
                class="col-4"
                :key="index"
                :headline="`Title ${index}`"
                :items="group"
              />
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-card class="pa-4">
            <h1>Bar Charts</h1>
            <div class="d-flex flex-column justify-space-between">
              <chart-bars
                v-for="(block, index) in bars"
                :key="index"
                :type="block.type"
                :entry="block"
              />
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="4"
        >
          <v-card class="pa-4">
            <h1>Pie Charts <small>(Edge Cases)</small></h1>
            <div class="d-flex mt-2 justify-space-between">
              <chart-pie
                v-for="(group, index) in pie_edge_cases"
                :key="index"
                :items="group"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </section>
  </v-container>
</template>

<script>
export default {
  name: 'ModalDemo',

  data () {
    return {
      percentageValue: 0.168951,
      calculatedValue: 0,
      contractValue: 550000000 * 100,
      contractDate: '2022-01-01',
      currency: {
        key: 'PLN',
        value: 4.7
      },
      currencies: [
        { key: 'EUR', value: 1 },
        { key: 'PLN', value: 4.7 }
      ],
      imageHash: 360,
      // all props will be merged into component scope
      scope1: {
        // specify "model" to enable vue-style binding
        // or "value" for just passing data without 2-way binding
        value: 5,
        title: 'test'
      },
      scope2: {
        model: 3,
        title: 'other test'
      },
      // props for v-dialog api
      modalOptions: {
        maxWidth: 500
      },
      eventPayload: {},

      // Charts
      pie_data: [
        [
          { label: 'Finalised', value: 16 },
          { label: 'Pending', value: 5 },
          { label: 'Rejected', value: 12 }
        ],
        [
          { label: 'Eeny', value: 3 },
          { label: 'Meeny', value: 2 },
          { label: 'Miny-Moh', value: 1 }
        ],
        [
          { label: 'Ticked off', value: 4 },
          { label: 'Open', value: 8 },
          { label: 'Overdue', value: 5 }
        ]
      ],
      pie_edge_cases: [
        [
          { label: 'Label One', value: 60 },
          { label: 'Label Two', value: 50 },
          { label: 'Label Three', value: 40 },
          { label: 'Label Four', value: 30 },
          { label: 'Label Five', value: 20 },
          { label: 'Label Six', value: 10 }
        ],
        [{ label: 'Some' }, { label: 'Empty' }, { label: 'Fields' }]
      ],
      bars: [
        {
          type: 'amount',
          label: 'Paid',
          original: 9000000,
          current: 9199000,
          value: 6899250
        },
        { label: 'Time', original: 525, current: 550, value: 333 }
      ]
    }
  },
  methods: {
    handleDemo1Click (e) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'Dummy',
        options: this.modalOptions,
        scope: this.scope1,
        handlers: { input: this.handleInputFromAnotherWorld }
      })
    },
    handleDemo2Click (e) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'AnotherDummy',
        options: this.modalOptions,
        scope: this.scope2,
        handlers: { click: this.handleClickFromAnotherWorld }
      })
    },
    handleDemo3Click (e) {
      this.$eventBus.$on('CUSTOM_EVENT', this.handleCustomEvent)

      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'DummyWithEventBus',
        options: this.modalOptions
      })
    },
    // just test handler
    handleClickFromAnotherWorld (e) {
      console.log('Click from another world:', e)
      this.imageHash++
    },
    handleInputFromAnotherWorld (value) {
      this.scope1.value = value
    },
    handleCustomEvent (payload) {
      console.log('payload', payload)
      this.eventPayload = payload
      this.$eventBus.$emit('CLOSE_MODAL')
    }
  }
}
</script>
